export const router: CMx.RouterState = {
  location: {
    pathname: '',
    search: '',
    hash: '',
    key: ''
  },
  action: ''
};
